let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6YqGY")).then(() => parcelRequire('8EvCY'));